/**
 * inline [[]]
 * [[...]]
 */

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, ) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewFeatureWikiLink = this.HyperMD.PreviewFeatureWikiLink || {}), );
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = (function (md) {
        // @ts-ignore
        md.inline.ruler.before("autolink", "wikilink", function (state, silent) {
            if (!state.src.startsWith("[[", state.pos)) {
                return false;
            }
            var content = null;
            var tag = "]]";
            var end = -1;
            var i = state.pos + tag.length;
            while (i < state.src.length) {
                if (state.src[i] === "\\") {
                    i += 1;
                }
                else if (state.src.startsWith(tag, i)) {
                    end = i;
                    break;
                }
                i += 1;
            }
            if (end >= 0) {
                // found ]]
                content = state.src.slice(state.pos + tag.length, end);
            }
            else {
                return false;
            }
            if (content && !silent) {
                var token = state.push("wikilink");
                token.content = content;
                state.pos += content.length + 2 * tag.length;
                return true;
            }
            else {
                return false;
            }
        });
        md.renderer.rules.wikilink = function (tokens, idx) {
            var content = tokens[idx].content;
            if (!content) {
                return;
            }
            var splits = content.split("|");
            var linkText, wikiLink;
            if (splits.length === 2) {
                wikiLink = splits[0].trim();
                linkText = splits[1].trim();
            }
            else {
                linkText = splits[0].trim();
                wikiLink = splits[0].trim();
            }
            return "<a href=\"" + wikiLink + "\" data-wikilink-url=" + wikiLink + ">" + linkText + "</a>";
        };
    });
});
